var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgU3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.09379,
    cy: 3.80604,
    r: 3.44121,
    fill: "#78B1BE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.40625 12.578C0.40625 10.3689 2.19711 8.57802 4.40625 8.57802H9.78125C11.9904 8.57802 13.7812 10.3689 13.7812 12.578V13.6352C13.7812 14.7397 12.8858 15.6352 11.7812 15.6352H2.40625C1.30168 15.6352 0.40625 14.7397 0.40625 13.6352V12.578Z",
    fill: "#78B1BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgU3);
export default __webpack_public_path__ + "static/media/u3.98be7768667ead2ecbd06ff545c47898.svg";
export { ForwardRef as ReactComponent };